<!--
 * @Author: yinwenxuan yinwenxuan@vip56.cn
 * @Date: 2023-03-22 09:04:29
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2026-01-04 15:00:31
 * @FilePath: \PosManager-Front\src\views\h5\h5Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="a_main">
        <img class="icon_menu" src="@/assets/padImg/menu_l.png" alt="" @click="showSearch">
        <div class="search_box search_panel">
          <input class="si_input"  type="text" placeholder="请输入门店编号" v-model="searchValue.shopNo" maxlength="48" @input="filterSearch">
            <input class="si_input"  type="text" placeholder="请输入门店名称" v-model="searchValue.shopName" maxlength="48" @input="filterSearch">
            <input class="si_input"  type="text" placeholder="请输入订单编号" v-model="searchValue.orderNo" maxlength="48" @input="filterSearch">

            <select class="si_input si_box" v-model="shopTypeval" @change="filterSearch">
              <option v-for="(item,index) in shopTypeOptions" :key="index" :value="item.value">{{item.label}}</option>
          </select>
            <div class="si_input si_box" @click="openselDate(true)">
                <div class="val" :class="!(startDate && endDate) ? 'hTxt' : ''">
                {{
                    startDate && endDate ? startDate + " - " + endDate : "开始日期 - 结束日期"
                }}
                </div>
            </div>

            <select class="si_input si_box" v-model="payType" @change="filterSearch">
              <option v-for="(item,index) in payOptions" :key="index" :value="item.value">{{item.label}}</option>
          </select>

            <div class="sbtn_group">
              <div class="si_input si_btn" @click="filterReset">重置</div>
              <div class="si_input si_btn" @click="filterSearch">搜索</div>
            </div>
        </div>
        <div class="huadong huadongpc" style="height:calc(100% - 7.19vw);">
        <div class="table_th" >
          <div class="tt ">门店编号</div>
          <div class="tt ">订单编号</div>
          <div class="tt ">支付方式</div>
          <div class="tt ">订单金额</div>
          <div class="tt tt1">创建时间</div>
        </div>
        <div class="list_box" >
          <div class="table_con">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list v-model="loading" :finished="finished" @load="loadMore">
                <div v-if="list.length > 0">
                  <div class="t_box">
                    <div
                      class="tb_i"
                      v-for="(item, index) in list"
                      :key="index"
                      @click="viewdetail(item)"
                    >
                      <div class="ti  ">
                        {{ item.shopNo }}
                      </div>
                      <div class="ti ">
                        {{item.orderNo}}
                      </div>
                      <div class="ti " >
                        <div v-if="item.paymentMethod == 1">会员卡</div>
                        <div v-if="item.paymentMethod == 2">现金</div>
                        <div v-if="item.paymentMethod == 3">微信</div>
                        <div v-if="item.paymentMethod == 4">支付宝</div>
                        <div v-if="item.paymentMethod == 5">现金/会员卡/微信</div>
                        <div v-if="item.paymentMethod == 6">现金/会员卡/支付宝</div>
                        <div v-if="item.paymentMethod == 7">现金/微信</div>
                        <div v-if="item.paymentMethod == 8">现金/支付宝</div>
                        <div v-if="item.paymentMethod == 9">会员卡/微信</div>
                        <div v-if="item.paymentMethod == 10">会员卡/支付宝</div>
                        <div v-if="item.paymentMethod == 11">现金/会员卡</div>
                        <div v-if="item.paymentMethod == 13">线下微信</div>
                        <div v-if="item.paymentMethod == 14">线下支付宝</div>
                        <div v-if="item.paymentMethod == 15">现金/线下支付宝</div>
                        <div v-if="item.paymentMethod == 16">会员卡/线下支付宝</div>
                        <div v-if="item.paymentMethod == 17">现金/线下微信</div>
                        <div v-if="item.paymentMethod == 18">会员卡/线下微信</div>
                        <div v-if="item.paymentMethod == 19">线下微信/线下支付宝</div>
                        <div v-if="item.paymentMethod == 20">现金/会员卡/线下支付宝</div>
                        <div v-if="item.paymentMethod == 21">现金/会员卡/线下微信</div>
                        <div v-if="item.paymentMethod == 22">现金/线下支付宝/线下微信</div>
                        <div v-if="item.paymentMethod == 23">会员卡/线下支付宝/线下微信</div>
                      </div>
                      <div class="ti ">
                        {{item.amount}}
                      </div>
                      <div class="ti ti1">
                        {{item.createTime}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="empty_table_con ec2" v-if="list.length == 0 && !loading">
                  <div class="tc">
                    <img src="@/assets/padImg/empty.png" alt="" />
                    <div class="txt">暂无数据</div>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </div>
      </div>
        
        <van-calendar
        v-model="pickerShow"
        color="#CEB57D"
        allow-same-day
        ref="calendar"
        :minDate="minDate"
        :maxDate="maxDate"
        type="range"
        title="时间范围"
        :default-date="defaultDate"
        @confirm="onselConfirm"
        />

        <!-- 支付方式 -->
         <van-popup
          v-model="payMethodShow"
          position="bottom"
          :style="{ height: '50%' }"
          v-if="payMethodShow"
        >
        <van-picker
            value-key="label"	
            show-toolbar
            :columns="payOptions"
            @confirm="onConfirmPm"
            @cancel="onCancelPm"
            :default-index="defaultIndex"
          />
        </van-popup>

         <!-- 门店类型 -->
         <van-popup
          v-model="typeShow"
          position="bottom"
          :style="{ height: '50%' }"
          v-if="typeShow"
        >
        <van-picker
            value-key="label"	
            show-toolbar
            :columns="shopTypeOptions"
            @confirm="onConfirmType"
            @cancel="onCancelType"
            :default-index="defaultTypeIndex"
          />
        </van-popup>

        <van-popup
        v-model="searchShow"
        closeable
        position="bottom"
        :style="{ height: '80%' }"
        round
      > 
        <div class="search_tit">搜索项</div>
        <div class="search_box">
            <input class="si_input"  type="text" placeholder="请输入门店编号" v-model="searchValue.shopNo" maxlength="48" >
            <input class="si_input"  type="text" placeholder="请输入门店名称" v-model="searchValue.shopName" maxlength="48" >
            <input class="si_input"  type="text" placeholder="请输入订单编号" v-model="searchValue.orderNo" maxlength="48" >
            <div class="si_input si_box" @click="showType">
                {{shopType}}
            </div>
            <div class="si_input si_box" @click="openselDate(false)">
                <div class="val" :class="!(startDate && endDate) ? 'hTxt' : ''">
                {{
                    startDate && endDate ? startDate + " - " + endDate : "开始日期 - 结束日期"
                }}
                </div>
            </div>
            <div class="si_input si_box" @click="showPm">
                {{getPayStatus}}
            </div>
            <div class="sbtn_group">
              <div class="si_input si_btn" @click="filterSearch">搜索</div>
              <div class="si_input si_btn" @click="filterReset">重置</div>
            </div>
            
        </div>
    </van-popup>
    </div>
</template>

<script>
import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';
import dayjs from "dayjs";
import { Operations } from '@/http/api_Operations';
import { filter } from 'jszip';
export default{
    components:{
    },
    data(){
        return{
            searchValue:{
                shopNo:'',
                shopName:'',
                type:'',
                orderNo:'',
                paymentMethod:'',
                nowPaymentMethod:'',
                startTime:'',
                endTime:'',
                skip:0,
                count:20
            },
            startDate: '',
            endDate: '',
            pickerShow:false,
            minDate:new Date(new Date().getFullYear() - 1, 0, 1),
            maxDate:new Date(new Date().getFullYear() , new Date().getMonth(), new Date().getDate()),
            defaultDate:[],
            payOptions: [
            {
            label: "全部支付方式",
            value: null,
            },
            {
            label: "会员卡支付",
            value: 1,
            },
            {
            label: "现金支付",
            value: 2,
            },
            {
            label: "微信支付",
            value: 3,
            },
            {
            label: "支付宝支付",
            value: 4,
            },
            {
            label: "现金+会员卡+微信",
            value: 5,
            },
            {
            label: "现金+会员卡+支付宝",
            value: 6,
            },
            {
            label: "现金+微信",
            value: 7,
            },
            {
            label: "现金+支付宝",
            value: 8,
            },
            {
            label: "会员卡+微信",
            value: 9,
            },
            {
            label: "会员卡+支付宝",
            value: 10,
            },
            {
            label: "现金+会员卡",
            value: 11,
            },
            {
            label: "线下微信",
            value: 13,
            },
            {
            label: "线下支付宝",
            value: 14,
            },
            {
            label: "现金+线下支付宝",
            value: 15,
            },
            {
            label: "会员卡+线下支付宝",
            value: 16,
            },
            {
            label: "现金+线下微信",
            value: 17,
            },
            {
            label: "会员卡+线下微信",
            value: 18,
            },
            {
            label: "线下微信+线下支付宝",
            value: 19,
            },
            {
            label: "现金+会员卡+线下支付宝",
            value: 20,
            },
            {
            label: "现金+会员卡+线下微信",
            value: 21,
            },
            {
            label: "现金+线下支付宝+线下微信",
            value: 22,
            },
            {
            label: "会员卡+线下支付宝+线下微信",
            value: 23,
            },
        ],
        payType: null,
        defaultIndex:0,
        payMethodShow:false,
        /**列表加载相关 */
        refreshing: false,
        loading: false,
        finished: false,
        list: [],
        total: 0,
        currentPage: 1,
        shopTypeOptions:[
            {
              label: "全部门店类型",
              value: '',
            },
            {
              label: "聚合",
              value: '1',
            },
            {
              label: "直连",
              value: '2',
            }
        ],
        shopTypeval:'',
        searchShow:false,
        defaultTypeIndex:0,
        typeShow:false,
        isNeedjk:false,
        }
    },
    async mounted() {
        if(localStorage.getItem('internalSearchItem')){
          let sitem = JSON.parse(localStorage.getItem('internalSearchItem'));
          this.searchValue.shopNo = sitem.shopNo;
          this.searchValue.shopName = sitem.shopName;
          this.searchValue.type = sitem.type;
          this.searchValue.orderNo = sitem.orderNo;
          this.searchValue.paymentMethod = sitem.paymentMethod;
          this.searchValue.nowPaymentMethod = sitem.nowPaymentMethod;
          this.searchValue.startTime = sitem.startTime;
          this.searchValue.endTime = sitem.endTime;
          this.searchValue.skip = sitem.skip;
          this.searchValue.count = sitem.count;
          this.payType = sitem.payType;
          this.shopTypeval = sitem.shopTypeval;
          this.startDate = sitem.startDate;
          this.endDate = sitem.endDate;
          this.defaultDate = sitem.defaultDate;
          this.onRefresh();
        }
    },
    async created() {
        
    },
    computed:{
        getPayStatus() {
            let str = "";
            str = this.payOptions.find((v) => v.value == this.payType).label;
            return str;
        },
        shopType(){
          let str = "";
          str = this.shopTypeOptions.find((v) => v.value == this.shopTypeval).label;
          return str;
        }
    },
    methods:{
        openselDate(val) {
            this.isNeedjk = val;
            this.pickerShow = true;
        },
        /**确定选择时间 */
        onselConfirm(date) {
            const [start, end] = date;
            this.startDate = dayjs(start).format("YYYY-MM-DD");
            this.endDate = dayjs(end).format("YYYY-MM-DD");

            this.pickerShow = false;
            if(this.isNeedjk){
              this.filterSearch();
            }
            
        },
        closeTime() {
            this.pickerShow = false;
        },
        async setTimeSearch() {
            this.searchValue.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
            this.searchValue.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
       
         
        },
        showPm(){
            this.defaultIndex = this.payOptions.some(v=>v.value==this.payType)?this.payOptions.findIndex(v=>v.value==this.payType):0;
            this.payMethodShow = true;
        },
        onConfirmPm(event){
        this.payType = event.value;
        this.payMethodShow = false;    
        },
        onCancelPm(){
            this.payMethodShow = false;
        },
        showType(){
            this.defaultTypeIndex = this.shopTypeOptions.some(v=>v.value==this.shopTypeval)?this.shopTypeOptions.findIndex(v=>v.value==this.shopTypeval):0;
            this.typeShow = true;
        },
        onConfirmType(event){
        this.shopTypeval = event.value;
        this.typeShow = false;    
        },
        onCancelType(){
            this.typeShow = false;
        },
        /**下拉刷新 */
        onRefresh() {
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.searchValue.skip = 0;
            this.searchValue.count = 20;
            this.currentPage = 1;
            this.loadMore();
        },
        /**触底加载 */
        async loadMore() {
           
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            let s = this.searchValue.count;
           let res = await Operations.GetTbPayResultList(Object.assign({}, this.searchValue));
                this.list =
                this.searchValue.skip == 0
                    ? res.items.map((v) => {
                        return {
                        ...v,
                        orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                        };
                    })
                    : this.list.concat(
                        res.items.map((v) => {
                        return {
                            ...v,
                            orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                        };
                        })
                    );
                this.total = res.totalCount;
                this.iscz = false;

            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            }
        },
        /**获取商品列表 */
        async getList() {
            this.onRefresh();
        },
        /**重置 */
        resetSearch() {
            this.searchValue={
                shopNo:'',
                shopName:'',
                type:'',
                orderNo:"",
                paymentMethod:'',
                nowPaymentMethod:'',
                startTime:'',
                endTime:'',
                skip:0,
                count:20
            };
            this.payType = null;
            this.shopTypeval = "";
            this.startDate = '';
            this.endDate = '';
            this.defaultDate = [];
            this.iscz = true;
            this.getList();
        },
        viewdetail(item){
          localStorage.setItem('abnormalDetail',JSON.stringify(item));
          this.$router.push("/internal/abnormalDetail")
        },
        showSearch(){
          this.searchShow = true;
        },
        async filterSearch(){
          this.searchValue.type =  this.shopTypeval?this.shopTypeOptions.find(v=>v.value==this.shopTypeval).label:'';
          this.searchValue.paymentMethod = this.payType;
          await this.setTimeSearch();
          await this.getList();
          this.searchShow = false;
          let form = Object.assign({},this.searchValue,{
              payType: this.payType,
              shopTypeval:this.shopTypeval,
              startDate:this.startDate,
              endDate:this.endDate,
              defaultDate:this.defaultDate
        })
        localStorage.setItem('internalSearchItem',JSON.stringify(form));
        },
        filterReset(){
          localStorage.removeItem('internalSearchItem')
          this.resetSearch();
          this.searchShow = false;
        }
    }
    
}
</script>

<style lang="scss" scoped>
@function px2vw($n) {
    @return ($n / 374 * 100) * 1vw;
}
div{
    box-sizing: border-box;
}
.a_main{
    font-size: px2vw(12);
    .icon_menu{
      display: block;
      width: px2vw(20);
      height: px2vw(20);
      margin: px2vw(15);
    }
    .search_tit{
      text-align: center;
      font-size: px2vw(20);
      padding: px2vw(20) 0;
    }
    .search_box{
        padding: px2vw(15) px2vw(10);
        .si_input{
            width: 100%;
            height: px2vw(40);
            display: block;
            font-size: px2vw(16);
            margin-bottom: px2vw(10);
            &.si_btn,&.si_box{
                border: 1px solid rgb(118, 118, 118);
                display: flex;
                align-items: center;
            }
            &.si_box{
                padding-left: px2vw(5);
            }
            &.si_btn{
                justify-content: center;
            }
        }
    }
    .sbtn_group{
        display: flex;
        justify-content: center;
        .si_btn{
          width: 45%;
          margin-right: px2vw(10);
          &:last-child{
            margin-right: 0;
          }
        }
    }
    .huadong {
      overflow-x: auto;
    }
    .table_th {
      width: max-content;
      height: px2vw(40);
      background: #e5e9f0;
      font-size: px2vw(13);
      font-weight: bold;
      letter-spacing: 0px;
      color: #3d3d3d;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      .tt {
        text-align: center;
        width: 120px;
        box-sizing: border-box;
        &.tt1{
          width: 200px;
        }
      }
      
    }
    .list_box {
      height:80vh;
      overflow-y: auto;
      box-sizing: border-box;
      width: max-content;
      .p_box {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 100%;
        .lb_i {
          width: 20.13vw;
          height: 6.59vw;
          border: 1px solid #d8d8d8;
          border-radius: 0.29vw;
          margin: 0 0 0.8vw 0.8vw;
          display: flex;
          overflow: hidden;
          position: relative;
          .xj_status {
            display: block;
            width: 5.86vw;
            height: 2.2vw;
            position: absolute;
            right: 0;
            top: 0;
          }
          .li_img {
            display: block;
            width: 6.71vw;
            height: 100%;
            margin-right: 0.73vw;
          }
          .li_info {
            width: calc(100% - 7.44vw);
            padding-top: 0.44vw;
            box-sizing: border-box;
            .name {
              font-size: 1.17vw;
              font-weight: bold;
              line-height: 1.46vw;
              letter-spacing: 0px;
              color: #1a1a1a;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              width: 95%;
              margin-bottom: 0.51vw;
            }
            .num {
              font-size: 1.02vw;
              font-weight: bold;
              line-height: 1.46vw;
              letter-spacing: 0px;
              color: #1a1a1a;
            }
            .b_i {
              display: flex;
              justify-content: space-between;
              width: 95%;
              margin-top: 0.95vw;
              .val {
                font-size: 1.02vw;
                font-weight: bold;
                line-height: 1.46vw;
                letter-spacing: 0px;
                color: #fa5151;
              }
              .stock {
                font-size: 0.88vw;
                font-weight: bold;
                line-height: 1.46vw;
                letter-spacing: 0px;
                color: #4e5969;
              }
            }
          }
        }
      }
     
      .t_box {
        .tb_i {
          width: 100%;
          height: px2vw(40);
          display: flex;
          align-items: center;
          border-bottom: 0.0037vw solid #d8d8d8;
          .ti {
            text-align: center;
            width:120px;
            box-sizing: border-box;
            font-size: px2vw(14);
            // font-weight: bold;
            line-height:  px2vw(40);
            color: #333c49;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            &.ti1{
              width: 200px;
            }
            
          }
        }
      }
      .table_con {
        box-sizing: border-box;
      }
      .tcon3 {
        width: max-content;
      }
    }
}
/deep/ .ec2{
    margin-left: 32vw;
}
@media screen and (max-width:1024px) {
  .a_main{
    .search_panel{
      display: none;
    }
  }
}
@media screen and (min-width:1024px) {
  .a_main{
    .icon_menu{
      display: none;
    }
    .search_panel{
      padding: 20px 20px 80px 20px;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .si_input{
        width: 14vw;
        height: 40px;
        font-size: 14px;
        margin-right: 2vw;
        margin-bottom: 0;
        &:last-child{
          margin-right: 0;
        }
      }
      .sbtn_group{
        position: absolute;
        right: 90px;
        top: 80px;
        .si_btn{
          width: 120px;
        }
      }
    }
    .huadongpc{
      height: calc(100vh - 210px)!important;
    }
    .table_th{
      width: 100%;
      height: 50px;
      .tt {
        width: calc(100% / 5);
        font-size: 16px;
        &.tt1{
          width: calc(100% / 5);
        }
      }
    }
    .list_box{
      width: 100%;
      height: calc(100% - 50px);
      .t_box{
         .tb_i{
            height: 50px;
           .ti{
             width: calc(100% / 5);
             font-size: 14px;
             height: 50px;
             line-height: 50px;
             &.ti1{
              width: calc(100% / 5);
             }
           }
         }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/internalH5/abnormalList.vue